<app-header-page *ngIf="visibleHeader">
    <h1>{{ 'HEADERS.DOC_PROPERTIES' | translate }}</h1>
</app-header-page>

<div class="super__tabs">
    <div (click)="getProperties('folder')" [class.active]="tab === 'folder'"
         class="super__tabs tab"
         data-action="folder">
        <span>{{ 'DOCUMENTS.TEXT.TABS.FOLDERS' | translate }}</span>
    </div>
    <div (click)="getProperties('collection')" [class.active]="tab === 'collection'"
         class="super__tabs tab"
         data-action="collection">
        <span>{{ 'DOCUMENTS.TEXT.TABS.COLLECTION' | translate }}</span>
    </div>
    <div (click)="getProperties('file')" [class.active]="tab === 'file'"
         class="super__tabs tab"
         data-action="file">
        <span>{{ 'DOCUMENTS.TEXT.TABS.FILES' | translate }}</span>
    </div>
</div>

<div class="tab__content">
    <ng-container *ngIf="tab === 'folder'">
        <ng-container *ngTemplateOutlet="props"></ng-container>
    </ng-container>
    <ng-container *ngIf="tab === 'collection'">
        <ng-container *ngTemplateOutlet="props"></ng-container>
    </ng-container>
    <ng-container *ngIf="tab === 'file'">
        <ng-container *ngTemplateOutlet="props"></ng-container>
    </ng-container>
</div>

<ng-template #props>
    <app-property-option-table
            (saveOptionProperty)="saveProp($event)"
            *ngIf="customProperties"
            [mode]="'doc'"

            [targetProperties]="customProperties"
    ></app-property-option-table>
</ng-template>

